module.exports = __webpack_public_path__ + "img/adobexd.6637196c.png";